const initialState = {
  JWT: '',
  email: '',
  volunteers: [],
};

export default initialState;
